import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private SupplierOfferPositionDecline Types */
import {
  _SupplierOfferPositionDeclines
} from '../namespace-helper'

export default {
  namespaced: true,
  state: {
    supplierOfferPositionDeclines: [],
    supplierOfferPositionDeclinesLoading: false
  },
  mutations: {
    [_SupplierOfferPositionDeclines.mutations.setSupplierOfferPositionDeclines] (state, payload) {
      state.supplierOfferPositionDeclines = payload
    },
    [_SupplierOfferPositionDeclines.mutations.setLoadSupplierOfferPositionDeclines] (state, payload) {
      state.supplierOfferPositionDeclinesLoading = payload
    }
  },
  actions: {
    [_SupplierOfferPositionDeclines.actions.saveSupplierOfferPositionDeclines] (context, payload) {
      context.commit(_SupplierOfferPositionDeclines.mutations.setLoadSupplierOfferPositionDeclines, true)

      const data = JSON.stringify(payload)

      if (payload.id === 0) {
        var url = API_URL + '/api/v1/supplierOfferPositionDeclines'

        return new Promise((resolve, reject) => {
          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            context.commit(_SupplierOfferPositionDeclines.mutations.setLoadSupplierOfferPositionDeclines, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            context.commit(_SupplierOfferPositionDeclines.mutations.setLoadSupplierOfferPositionDeclines, false)
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        })
      } else {
        url = API_URL + '/api/v1/supplierOfferPositionDeclines/' + payload.id

        return new Promise((resolve, reject) => {
          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            context.commit(_SupplierOfferPositionDeclines.mutations.setLoadSupplierOfferPositionDeclines, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            context.commit(_SupplierOfferPositionDeclines.mutations.setLoadSupplierOfferPositionDeclines, false)
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        })
      }
    },
    [_SupplierOfferPositionDeclines.actions.loadSupplierOfferPositionDeclinesByInquiryPositionID] (context, payload) {
      context.commit(_SupplierOfferPositionDeclines.mutations.setLoadSupplierOfferPositionDeclines, true)

      var url = API_URL + '/api/v1/supplierOfferPositionDeclines/inquiryPosition/' + payload.inquiries_positions_id + '/' + payload.suppliers_id
      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_SupplierOfferPositionDeclines.mutations.setLoadSupplierOfferPositionDeclines, false)
          ErrorHandler.clear(store)
          context.commit(_SupplierOfferPositionDeclines.mutations.setSupplierOfferPositionDeclines, r.data.data)
          resolve(r)
        }, function (err) {
          context.commit(_SupplierOfferPositionDeclines.mutations.setLoadSupplierOfferPositionDeclines, false)
          context.commit(_SupplierOfferPositionDeclines.mutations.setSupplierOfferPositionDeclines, [])
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOfferPositionDeclines.actions.removeSupplierOfferPositionDecline] (context, payload) {
      context.commit(_SupplierOfferPositionDeclines.mutations.setLoadSupplierOfferPositionDeclines, true)

      var url = API_URL + '/api/v1/supplierOfferPositionDeclines/' + payload
      return new Promise((resolve, reject) => {
        axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_SupplierOfferPositionDeclines.mutations.setLoadSupplierOfferPositionDeclines, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          context.commit(_SupplierOfferPositionDeclines.mutations.setLoadSupplierOfferPositionDeclines, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOfferPositionDeclines.actions.setSupplierOfferPositionDeclines] (context, payload) {
      context.commit(_SupplierOfferPositionDeclines.mutations.setSupplierOfferPositionDeclines, payload)
    },
    [_SupplierOfferPositionDeclines.actions.resetState] (context, payload) {
      context.commit(_SupplierOfferPositionDeclines.mutations.setSupplierOfferPositionDeclines, [])
    }

  },
  getters: {
    [_SupplierOfferPositionDeclines.getters.getSupplierOfferPositionDeclines] (state) {
      return state.supplierOfferPositionDeclines
    },
    [_SupplierOfferPositionDeclines.getters.getLoadingSupplierOfferDeclines] (state) {
      return state.setLoadSupplierOfferPositionDeclines
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/SupplierOfferPositionDeclines/supplierOffersPositionDeclines.js